import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types';
import { useSearchParams } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import ArrowBackIosNewSharpIcon from '@mui/icons-material/ArrowBackIosNewSharp';
import play from '../../../assets/images/CommonComponent/play.svg';
import pause from '../../../assets/images/CommonComponent/pause.svg';
import redCross from "../../../assets/images/CommonComponent/redCross.svg";
import Paper from '@mui/material/Paper';
import { visuallyHidden } from '@mui/utils';
import Divider from '@mui/material/Divider';
import styled from '@emotion/styled';
import Select from "react-select";
import { FormGroup, } from "reactstrap";
import { createNotification } from '../../../Config/NotificationToast';
import { getContentsList, } from '../../../redux/actions/ContentManagementAction/VideoPodcasts/VideoPodcastsAction';
import { deleteMasterDataModule } from '../../../redux/actions/MasterDataAction/RecipeCollection/RecipeCollectionAction';
import { updateIsActiveStatus } from '../../../redux/actions/MasterDataAction/ProgramAction/programActions';
import { stableSort, getComparator, rowOptions, options, getPermissionByAppName } from '../../../utils/Helper'
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import * as routes from "../../../Router/RoutesURL";
import './VideoPodcasts.scss';
import { Chip, CircularProgress } from '@mui/material';
import { tabKeys } from '../../../Config/Constant';
import moment from 'moment';
import ImageComponent from '../../../components/ImageComponent/ImageComponent';
import AudioPlayer from '../../../components/AudioPlayer/AudioPlayer';
import VideoComponent from '../../../components/VideoComponent';

const MainHeading = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
}))


const headCells = [
    {
        id: 'thumbnail',
        width: '140px',
        disablePadding: true,
        label: 'THUMBNAIL',
        disableSorting: true
    },
    {
        id: 'title',
        width: '170px',
        disablePadding: true,
        label: 'TITLE',
    },
    {
        id: 'content_type',
        width: '190px',
        disablePadding: false,
        label: 'CONTENT TYPE',
    },
    {
        id: 'duration',
        width: '150px',
        disablePadding: false,
        label: 'DURATION',
    },
    {
        id: 'category_name',
        width: '150px',
        disablePadding: false,
        label: 'CATEGORY',
    },
    {
        id: 'content_version',
        width: '160px',
        disablePadding: false,
        label: 'FREE / PAID',
    },
    {
        id: 'content_creation_datetime',
        width: '170px',
        disablePadding: false,
        label: 'CREATED ON',
    },
    {
        id: 'is_active',
        width: '130px',
        disablePadding: false,
        label: 'STATUS',

    },
    {
        id: 'action',
        width: '200px',
        disablePadding: false,
        label: 'ACTION',
        disableSorting: true
    },
];

const EnhancedTableHead = (props) => {
    const { order, orderBy, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align='left'
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                        sx={{minWidth: headCell.width, maxWidth: headCell.width}}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                            hideSortIcon={headCell.disableSorting}
                            disabled={headCell.disableSorting}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
    const { activeTab, setShowLoader } = props;
    const [searchParams, setSearchParams] = useSearchParams();
    const [searchText, setSearchText] = useState(searchParams.get('filter_text') || '');
    const [filterType, setFilterType] = useState(parseInt(searchParams.get('filter_type')) || 1);
    const filterAllBtn = ["btn btn-secondary", filterType === 1 ? "selButton" : "UnselButton"]
    const filterVideoBtn = ["btn btn-secondary", filterType === 3 ? "selButton" : "UnselButton"]
    const filterPodcastBtn = ["btn btn-secondary", filterType === 2 ? "selButton" : "UnselButton"]

    useEffect(() => {
        if (activeTab == tabKeys.contentManagement.VIDEO_AUDIO) {
            setSearchText(searchParams.get('filter_text') || '');
            setFilterType(parseInt(searchParams.get('filter_type')) || 1);
        }
    }, [activeTab, searchParams]);

    const selectContentType = (val) => {
        setShowLoader(true)
        setFilterType(val);
        const newParams = new URLSearchParams(searchParams);
        if (val !== 1) {
            newParams.set('filter_type', val);
        } else {
            newParams.delete('filter_type');
        }
        newParams.set('page', '1');
        setSearchParams(newParams, { replace: true });
    }
    const handleChangeSearch = (e) => {
        setShowLoader(true)
        const newSearchText = e.target.value;
        setSearchText(newSearchText);
        const newParams = new URLSearchParams(searchParams);
        if (newSearchText) {
            newParams.set('filter_text', newSearchText);
        } else {
            newParams.delete('filter_text');
        }
        newParams.set('page', '1');
        setSearchParams(newParams, { replace: true });
    }
    return (
        <div>
            <Toolbar sx={{
                pl: { sm: 2 },
                pt: { sm: 2 },
                pb: { sm: 2 },
                pr: { xs: 1, sm: 1 },

            }}
            >
                <div className='col-2 '>
                    <MainHeading
                        sx={{ flex: '1 1 100%', }}
                        variant="h6"
                        id="tableTitle"
                        component="div"
                    >
                        Content List
                    </MainHeading>
                </div>
                <div className='col-10 VideoLevelDiv'>
                    <button type="button" className={filterAllBtn.join(' ')} onClick={() => { selectContentType(1) }}>All</button>
                    <button type="button" className={filterVideoBtn.join(' ')} onClick={() => { selectContentType(3) }}>Videos</button>
                    <button type="button" className={filterPodcastBtn.join(' ')} onClick={() => { selectContentType(2) }}>Audio</button>
                    <div className="separator"></div>
                    <div className="mr-sm-2 searchDiv class-search ">
                        <input
                            value={searchText}
                            className="form-control mr-sm-2 class-search"
                            type="search"
                            placeholder=" Search Keyword"
                            aria-label="Search"
                            onChange={handleChangeSearch}
                        ></input>
                    </div>
                </div>
            </Toolbar>
            <Divider />
        </div>
    );
}

function containsAudioExtension(url) {
    const audioExtensions = ['mp3', 'wav', 'ogg', 'aac', 'flac', 'm4a', 'wma', 'opus'];
    const urlWithoutParams = url.split('?')[0]; // Remove query parameters
    const urlParts = urlWithoutParams.split('.');
    const extension = urlParts[urlParts.length - 1].toLowerCase();
    return audioExtensions.includes(extension);
}



const VideoPodcastsTable = (props) => {
    const { activeTab, permission } = props;
    const [searchParams, setSearchParams] = useSearchParams();
    const [order, setOrder] = useState(searchParams.get('order_by_type') || 'desc');
    const [orderBy, setOrderBy] = useState(searchParams.get('order_by') || 'content_creation_datetime');
    const [selected, setSelected] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(parseInt(searchParams.get('limit')) || 10);
    const navigate = useNavigate()
    const [showConfirm, setShowConfirm] = useState(false);
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const [selectedContentView, setSelectedContentView] = useState("");
    const [selectedContentStatus, setSelectedContentStatus] = useState("");
    const [viewContentsMainData, setViewContentsMainData] = useState('');
    const [showLoader, setShowLoader] = useState(true);
    const viewContentsDat = useSelector(state => state?.getContentsList);
    const loading = viewContentsDat.loadingVideoContent
    const {error} = viewContentsDat;
    const viewContentsDataRes = useSelector(state => state.getContentsList.videoContentList?.data);
    const myRef = useRef();
    const dispatch = useDispatch();



    useEffect(()=>{
        if(!loading)
            setShowLoader(false)
        if(!loading && !viewContentsDataRes && !error){
            setShowLoader(true)
        }
    }, [loading])

    useEffect(() => {
        if (activeTab == tabKeys.contentManagement.VIDEO_AUDIO) {
            const sendRequest = {
                "pageNo": searchParams.get('page') || 1,
                "pageSize": searchParams.get('limit') || 10,
                "filter_type": searchParams.get('filter_type') || 1,
                "filter_text": searchParams.get('filter_text') || '',
                "order": searchParams.get('order_by_type') || 'desc',
                "orderBy": searchParams.get('order_by') || 'content_creation_datetime',
                "category": 1
            };
            dispatch(getContentsList(sendRequest));
        }else{
            setOrder('desc');
            setOrderBy('content_creation_datetime');
            setRowsPerPage(10)
        }
    }, [activeTab, searchParams, dispatch]);


    useEffect(() => {
        if (viewContentsDat.error !== "No data found") {
            setViewContentsMainData(viewContentsDataRes && viewContentsDataRes?.content_data);
        } else {
            setViewContentsMainData('');
        }

    }, [viewContentsDataRes, viewContentsDat])

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        const newOrder = isAsc ? 'desc' : 'asc';
        setOrder(newOrder);
        setOrderBy(property);
        const newParams = new URLSearchParams(searchParams);
        newParams.set('order_by_type', newOrder);
        newParams.set('order_by', property);
        setSearchParams(newParams, { replace: true });
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = viewContentsMainData.map((n) => n.name);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };
    const handleChangePageNext = (newPage) => {
        setShowLoader(true)
        const nextPage = (viewContentsDataRes?.current_page_no || 0) + 1;
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', nextPage.toString());
        setSearchParams(newParams, { replace: true });
    };
    const handleChangePagePrev = (newPage) => {
        setShowLoader(true)
        const prevPage = (viewContentsDataRes?.current_page_no || 2) - 1;
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', prevPage.toString());
        setSearchParams(newParams, { replace: true });
    };

    const handleChangeRowsPerPage = (event) => {
        setShowLoader(true)
        const newRowsPerPage = parseInt(event.value, 10);
        setRowsPerPage(newRowsPerPage);
        const newParams = new URLSearchParams(searchParams);
        if (newRowsPerPage !== 10) {
            newParams.set('limit', newRowsPerPage.toString());
        } else {
            newParams.delete('limit');
        }
        newParams.set('page', '1');
        setSearchParams(newParams, { replace: true });
    };

    const handleChange = (contentId, type) => {
        if (permission === "write") {
            navigate(routes.ADD_VIDEO_PODCASTS, { state: { contentId, selection: type } })
        } else {
            createNotification('warning', "Access Restricted");
        }
    };

    const handleViewContent = (id, data) => {
        setSelectedContentView(data);
        setShowConfirm(true);
        setSelectedContentStatus(data.is_active)
    };
    const cancelWarnModal = (e) => {
        setShowConfirm(false);
        setSelectedContentView("");
        setSelectedContentStatus("");
    };

    const handleDeleteContent = (id, data) => {
        if (permission === "write") {
            setShowConfirmDelete(true);
            setSelectedContentView(data);
        } else {
            createNotification('warning', "Access Restricted");
        }
    };

    const DeleteContent = () => {
        const sendRequestDelete = {
            "feature_type": "content",
            "ids": selectedContentView.id,
            onSuccessCallback: ()=>{
                if(viewContentsDataRes?.start === viewContentsDataRes?.end){
                    const newParams = new URLSearchParams(searchParams);
                    newParams.set("page", (viewContentsDataRes?.current_page_no - 1 || 1));
                    setSearchParams(newParams, { replace: true });
                }else{
                    const sendRequest = {
                        "pageNo": viewContentsDataRes?.current_page_no || 1,
                        "pageSize": searchParams.get('limit') || 10,
                        "filter_type": searchParams.get('filter_type') || 1,
                        "filter_text": searchParams.get('filter_text') || '',
                        "order": searchParams.get('order_by_type') || '',
                        "orderBy": searchParams.get('order_by') || '',
                        "category": 1
                    };
                    dispatch(getContentsList(sendRequest));
                }
                setShowConfirmDelete(false);
            }
        };
        dispatch(deleteMasterDataModule(sendRequestDelete));
    }

    const CancelDeleteModal = (e) => {
        setShowConfirmDelete(false);
        setSelectedContentView("");
    };

    const handleChangeOption = (e, id) => {
        if (permission === "write") {
            if (e.value === "Active") {
                viewContentsMainData.find(v => v.id === id).is_active = 1;
                setSelectedContentStatus(1);
            } else {
                viewContentsMainData.find(v => v.id === id).is_active = 0;
                setSelectedContentStatus(0);
            }
            setViewContentsMainData(viewContentsMainData);
            const sendRequest = {
                "feature_type": "content",
                "id": id,
                "status": e.value === "Active" ? 1 : 0
            };
            dispatch(updateIsActiveStatus(sendRequest));
        } else {
            createNotification('warning', "Access Restricted");
        }
    }
    return (
        <>
            <Box sx={{ width: '100%' }} className="VideoBox h-100">
            <Paper className='d-flex flex-column' sx={{ width: '100%', mb: 1, borderRadius: 2, height: 'calc(100% - 57px)' }}>
                    <EnhancedTableToolbar setShowLoader={setShowLoader} activeTab={activeTab} />
                    {
                        showLoader ?
                        <div className='w-100 py-5 text-center'>
                            <CircularProgress sx={{'color': '#74613C'}}/>
                        </div>
                        :
                        viewContentsDataRes && viewContentsMainData ? <TableContainer sx={{ pt: 0, pr: 3, pb: 4, pl: 3, height: '100%' }}>
                            <Table
                                sx={{ minWidth: 750 }}
                                aria-labelledby="tableTitle"
                                stickyHeader
                                size='small'
                            >
                                <EnhancedTableHead
                                    numSelected={selected.length}
                                    order={order}
                                    orderBy={orderBy}
                                    onSelectAllClick={handleSelectAllClick}
                                    onRequestSort={handleRequestSort}
                                    rowCount={viewContentsDataRes && viewContentsDataRes?.content_data.length}
                                />
                                <TableBody>
                                    {
                                        viewContentsDataRes && viewContentsMainData
                                            .map((row, index) => {
                                                const labelId = `enhanced-table-checkbox-${index}`;

                                                return (
                                                    <TableRow hover onClick={(event) => handleClick(event, row.name)} role="checkbox"
                                                        tabIndex={-1}
                                                        key={row.id}
                                                    >



                                                        <TableCell component="th" id={labelId} scope="row"
                                                            padding="none"
                                                        >
                                                            <ImageComponent
                                                                path={row.media_thumbnail}
                                                                showPlayButton={true}
                                                                mediaType={row.content_type=='podcast' ? 'Audio': row.content_type}
                                                            />
                                                            {/* {
                                                                row.media ?
                                                                <div className='imgDivContent'>
                                                                    {row.media_thumbnail && <img className="mainIcon" src={row.media_thumbnail} alt="" width="60px" height="60px" />}
                                                                    <img className="videoPlayIcon" src={playOutlineFilled} alt="" width="60px" height="60px" />
                                                                </div>
                                                                :
                                                                <div className='notUploaded'>
                                                                     not uploaded
                                                                </div>
                                                            } */}
                                                        </TableCell>
                                                        <TableCell align="left" padding="none" >
                                                            <p className='titleText othText'>
                                                                {row.title}
                                                            </p>
                                                        </TableCell>
                                                        <TableCell align="left"><p className='othText'>{row.content_type=='podcast' ? 'audio': row.content_type}</p></TableCell>
                                                        <TableCell align="left">{row.duration}</TableCell>
                                                        <TableCell align="left"><p className='othText'>{row.category_name}</p></TableCell>
                                                        <TableCell align="left">
                                                            {row.content_version !== "free" ?
                                                                <div className='contentTypeText'>
                                                                    <p className='othText'>{row.content_version}</p>
                                                                    <p className='rupeesText'>- ₹{row.amount}</p></div> : <p className='othText'>{row.content_version}</p>}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            <p className='othText'>{moment(row.content_creation_datetime).format('DD/MM/YYYY')}</p>
                                                        </TableCell>
                                                        <TableCell align="left" width="10px" sx={{ color: row.is_active == 1 ? '#000000' : "#AAAAAA" }}>
                                                            <Select
                                                                className="react-select status-select"
                                                                classNamePrefix="react-select"
                                                                onChange={(e) => { handleChangeOption(e, row.id) }}
                                                                value={row.is_active === 1 ? { label: "Active", value: "Active" } : { label: "Inactive", value: "Inactive" }}
                                                                options={options}
                                                                isSearchable={false}
                                                                menuPlacement="auto"
                                                                menuPosition="absolute"   
                                                                menuPortalTarget={null}
                                                                theme={(theme) => ({
                                                                    ...theme,
                                                                    isFocused: "#74613C",
                                                                    colors: {
                                                                        ...theme.colors,
                                                                        primary25: '#F5F5F5',
                                                                        primary: '#f6f4f0',

                                                                    },
                                                                })}
                                                                getOptionLabel={(row) => (
                                                                    <><span className={row.label === "Active" ? "ActiveClass" : "InactiveClass"}
                                                                    >
                                                                        {row.label}
                                                                    </span>
                                                                        {row.is_active === 1 && (
                                                                            <div

                                                                            ></div>
                                                                        )}
                                                                    </>
                                                                )}
                                                            />
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            <ul className="list-group d-flex flex-row ">
                                                                <li
                                                                    className={row.is_active == 1 ? 'list-group-item ViewEditClick p-0 ' : "list-group-item ViewEditNotClick p-0"}
                                                                    onClick={row.is_active == 1 ? () => { handleViewContent(row.id, row) } : ""}><i className="fas fa-eye mr-1"></i> View</li>
                                                                {
                                                                    getPermissionByAppName("Content Management") === "write" &&
                                                                    <>
                                                                        <li className={row.is_active == 1 ? 'list-group-item ViewEditClick p-0 ' : "list-group-item ViewEditNotClick p-0"}
                                                                            onClick={row.is_active == 1 ? () => { handleChange(row.id, "edit") } : ""} ><i className="fa fa-pen mr-1"></i> Edit</li>
                                                                        <li className="list-group-item Delete p-0" onClick={() => { handleDeleteContent(row.id, row) }}><i className="fa fa-trash mr-1"></i> Delete</li>
                                                                    </>
                                                                }
                                                            </ul>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        : <div className='text-center w-100 text-muted mt-3'>No Records</div>
                    }
                </Paper>
                {
                    viewContentsMainData &&
                    <div className='paginationBlock'>
                        <div className='textData'><p>Items per page: </p></div>
                        <FormGroup className="FormGroup has-float-label rowsSelect class-menu-dropdown ">
                            <Select
                                placeholder={rowsPerPage}
                                className="react-select"
                                classNamePrefix="react-select"
                                value={rowsPerPage}
                                options={rowOptions}
                                menuPlacement="top"
                                menuPosition="fixed"
                                isSearchable={false}
                                onChange={handleChangeRowsPerPage}
                                theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary25: '#F5F5F5',
                                        primary: '#74613C',
                                    },
                                })}
                            />
                        </FormGroup>
                        {viewContentsDataRes?.content_data && <p className='endText'>   {viewContentsDataRes?.start} - {viewContentsDataRes?.end} of {viewContentsDataRes?.total}</p>}
                        <p>
                            
                            <button className={`btnPrev ${viewContentsDataRes?.current_page_no === 1 ? "opacityBtns" : ''}`} disabled={viewContentsDataRes?.current_page_no === 1} onClick={() => { handleChangePagePrev() }}>
                                <ArrowBackIosNewSharpIcon className='iconBtn' />
                            </button> 
                            <button className={`btnPrev ${viewContentsDataRes?.current_page_no === viewContentsDataRes?.total_pages ? "opacityBtns" : ''}`} disabled={viewContentsDataRes?.current_page_no === viewContentsDataRes?.total_pages} onClick={() => { handleChangePageNext() }}>
                                <ArrowForwardIosSharpIcon className='iconBtn' />
                            </button></p>
                    </div>
                }
            </Box>

            <Modal  centered className="viewContent-modal-warning br-8" show={showConfirm} onHide={() => { setShowConfirm(false); }}>
                <form>
                    <Modal.Header>
                        <div className="modalText pb-4">{selectedContentView.title}</div>
                        <Select
                            className={selectedContentStatus === 1 ? "react-select" : "react-selectChange"}
                            classNamePrefix="react-select"
                            onChange={(e) => { handleChangeOption(e, selectedContentView.id) }}
                            value={selectedContentStatus === 1 ? { label: "Active", value: "Active" } : { label: "Inactive", value: "Inactive" }}
                            options={options}
                            isSearchable={false}
                            theme={(theme) => ({
                                ...theme,
                                isFocused: "#74613C",
                                colors: {
                                    ...theme.colors,
                                    primary25: '#F5F5F5',
                                    primary: '#f6f4f0',

                                },
                            })}
                            getOptionLabel={(row) => (
                                <><span className={row.label === "Active" ? "ActiveClass" : "InactiveClass"}
                                >
                                    {row.label}
                                </span>
                                    {row.is_active === 1 && (
                                        <div

                                        ></div>
                                    )}
                                </>
                            )}
                        />
                    </Modal.Header>
                    <Modal.Body  style={{maxHeight: '60vh', overflowY: 'auto', overflowX: 'hidden'}}>

                        <div className="modalData">
                            {selectedContentView.media ?<div className='imgDivContent'>
                                    {
                                        containsAudioExtension(selectedContentView.media) ?
                                        <AudioPlayer 
                                            path={selectedContentView.media} 
                                            thumbnilPath={selectedContentView.media_thumbnail}
                                            audioDuration={selectedContentView?.duration} />
                                        :
                                        <VideoComponent
                                            path={selectedContentView.media}
                                            thumbnilPath={selectedContentView.media_thumbnail}
                                        />
                                    }
                            </div>:<div className='noVideoDiv'>
                                <p className='textNoVideo'>{selectedContentView.content_type=='podcast' ? 'Audio': 'Video'} not uploaded</p>
                                </div>}
                            <div className='dataContent'>
                                <div className='firstCol'>
                                    <div className='titleTextData'><p className='headeTitle'>Content Type:</p><p className='othText'>{selectedContentView.content_type=='podcast' ? 'audio': selectedContentView.content_type}</p></div>
                                    <div className='titleTextData'><p className='headeTitle'>Category:</p><p className='othText'>{selectedContentView.category_name}</p></div>
                                </div>
                                <div className='secondCol'>
                                    <div className='titleTextData'><p className='headeTitle'>Duration:</p><p>{selectedContentView.duration}</p></div>
                                    <div className='titleTextData'><p className='headeTitle'>Free / Paid:</p>
                                        {selectedContentView.content_version !== "free" ?
                                            <div className='contentTypeText'>
                                                <p className='othText'>{selectedContentView.content_version}</p>
                                                <p className='rupeesText'>- ₹{selectedContentView.amount}</p></div> : <p className='othText'>{selectedContentView.content_version}</p>}
                                    </div>

                                </div>
                            </div>
                            <div className='mx-4'>
                                {/* <div className='titleTextData'>
                                    <p className='headeTitle'>Short Description:</p>
                                    <p className='othText'>{selectedContentView.short_description || '-'}</p>
                                </div> */}

                                <div className='titleTextData'>
                                    <p className='headeTitle'>Tags:</p>
                                    <p className='othText'>{selectedContentView.tags || '-'}</p>
                                    {/* <p className='othText'>
                                        {
                                            selectedContentView?.tags && JSON.parse(selectedContentView?.tags)?.map((item, index) => {
                                                return <Chip label={item} color="primary" className='mr-2 mb-2 border-2' key={index} />
                                            })
                                        }
                                    </p> */}
                                </div>
                            </div> 
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-danger redButton mr-3" onClick={cancelWarnModal}>
                            <img className="mainIcon mr-2" src={redCross} alt="" width="16px" height="16px" />
                            CLOSE</button>
                    </Modal.Footer>
                </form>
            </Modal>
            <Modal centered className="TeamMember-modal-warning br-8" show={showConfirmDelete} onHide={() => { setShowConfirmDelete(false) }}>
                <Modal.Header>
                    <div className="modalText pb-4">Are you sure?</div>
                </Modal.Header>
                <Modal.Body>
                    <div className="">
                        <label htmlFor="exampleFormControlInput1" className="form-label DeleteDesc">You want to delete this record?</label>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-success greenButton mr-3" onClick={CancelDeleteModal}>
                        Cancel</button>
                    <button type="button" className="btn btn-danger redButton " onClick={DeleteContent}>
                        Delete</button>
                </Modal.Footer>
            </Modal>
        </>

    );
}
export default VideoPodcastsTable;